export default "__VITE_PUBLIC_ASSET__471060c7__"